exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AboutHorizons2020 img {\n  display: inline-block;\n  width: auto;\n  height: 40px;\n  margin-right: 20px;\n  opacity: 0.9;\n  transition: opacity 0.15s ease-in-out; }\n  a:hover .AboutHorizons2020 img {\n    opacity: 1; }\n", ""]);

// exports
